import _ from 'lodash';
import BaseForm from './base';
import { equipment } from './equipment';
import panels from './panels';
import { RawJSONForm } from './rawjson';
import { organizations } from './organizations';
import SelectRule from './rules/SelectRule';
import SimpleAction from './rules/SimpleAction';
import NotifyEmail from './rules/NotifyEmail';
import NotifyTextMessage from './rules/NotifyTextMessage';
export const forms = {
    equipment,
    panels,
    organizations,
    'select rule': SelectRule,
    'simple action': SimpleAction,
    'notify email': NotifyEmail,
    'notify text message': NotifyTextMessage,
    get rawjson() {
        return new RawJSONForm();
    },
    get base() {
        return new BaseForm();
    }
};
export class FormSchemas {
    forms = forms;
    static async generate(formType) {
        if (!_.has(forms, formType)) {
            formType = 'base';
        }
        const form = _.get(forms, formType);
        if (form.nonStatic) {
            const formObj = new form();
            await formObj.load();
            return formObj;
        }
        return form;
    }
    static getFormModelStructure(formType) {
        const form = _.get(forms, formType);
        if (form && form.getModelStructure) {
            return form.getModelStructure();
        }
    }
}
